import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Invites } from "./admin/Invites";
import { ArtistsAdmin, TracksAdmin } from "./admin/Approvals";
import { ArticlesAdmin } from "./admin/Articles";
import { Orders, Subscribers, FlamesAdmin } from "./admin/Business";
import { EmailsAdmin } from "./admin/Emails";
import { InstagramAdmin } from "./admin/Instagram";
import { BattlesAdmin, BookingsAdmin } from "./admin/Battles";
import { TicketsAdmin } from "./admin/Tickets";
import { EventsAdmin } from "./admin/Events";

const Stat = ({ label, value, testid }) => (
  <div className="panel p-5" data-testid={testid}><div className="led text-3xl font-bold">{value}</div><div className="mt-1 font-mono text-[10px] uppercase tracking-widest text-slate-500">{label}</div></div>
);

const Overview = () => {
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setO(r.data)); }, []);
  if (!o) return null;
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4" data-testid="admin-overview">
      <Stat label="Revenue this month" value={`€${o.revenue_month}`} testid="admin-revenue-month" />
      <Stat label="Revenue total" value={`€${o.revenue_total}`} testid="admin-revenue-total" />
      <Stat label="Paid / active plans" value={o.subscribers} testid="admin-subscribers" />
      <Stat label="Approved artists" value={o.artists} testid="admin-artists" />
      <Stat label="Artists to review" value={o.pending_artists} testid="admin-pending-artists" />
      <Stat label="Tracks to review" value={o.pending_tracks} testid="admin-pending-tracks" />
      <Stat label="Orders to deliver" value={o.open_orders} testid="admin-open-orders" />
      <Stat label="Founding spots used" value={`${o.founding_taken}/${o.founding_limit}`} testid="admin-founding" />
      <Stat label="Invites sent / signed up" value={`${o.invites}/${o.invites_signed}`} testid="admin-invites-stat" />
    </div>
  );
};

const TABS = [["overview", "Overview", Overview], ["tickets", "Tickets", TicketsAdmin], ["instagram", "Instagram", InstagramAdmin], ["invites", "Invites", Invites], ["artists", "Artists", ArtistsAdmin], ["tracks", "Tracks", TracksAdmin], ["events", "Events", EventsAdmin],
  ["articles", "Magazine", ArticlesAdmin], ["orders", "Orders", Orders], ["subs", "Subscribers", Subscribers], ["battles", "Battles", BattlesAdmin], ["bookings", "Bookings", BookingsAdmin], ["flames", "Flames", FlamesAdmin], ["emails", "Emails & jobs", EmailsAdmin]];

export default function Admin() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user || user.role !== "admin") return <Navigate to="/login" />;
  return (
    <div className="mx-auto max-w-7xl px-4 pb-32 pt-24 md:px-8" data-testid="admin-page">
      <div className="label-mono">Control room</div>
      <h1 className="mb-8 mt-2 font-display text-4xl font-black uppercase">Admin</h1>
      <Tabs defaultValue={new URLSearchParams(window.location.search).get("tab") || "overview"}>
        <TabsList className="no-scrollbar mb-8 flex h-auto w-full justify-start gap-1 overflow-x-auto rounded-full border border-white/10 bg-[#0F1420] p-1">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`} className="shrink-0 rounded-full px-4 py-2 font-mono text-[11px] uppercase tracking-widest data-[state=active]:bg-[#FF2E63] data-[state=active]:text-white">{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([v, , C]) => <TabsContent key={v} value={v}><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
